module.exports = __webpack_public_path__ + "img/logo.83744844.svg";